export enum countryList {
  Australia = 'Australia',
  Canada = 'Canada',
  New_Zealand = 'New Zealand',
  United_States = 'United States',
}

// 8 states and territories of Australia
export const statesAndTerritoriesOfAustralia = [
  'Australian Capital Territory',
  'New South Wales',
  'Northern Territory',
  'Queensland',
  'South Australia',
  'Tasmania',
  'Victoria',
  'Western Australia',
];

// 13 provinces and territories of Canada
export const provincesAndTerritoriesOfCanada = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon',
];

// 17 regions and territories of New Zealand
export const regionsAndTerritoriesOfNewZealand = [
  'Auckland',
  'Bay of Plenty',
  'Canterbury',
  'Chatham Islands Territory',
  'Gisborne',
  "Hawke's Bay",
  'Manawatū-Whanganui',
  'Marlborough',
  'Nelson',
  'Northland',
  'Otago',
  'Southland',
  'Taranaki',
  'Tasman',
  'Waikato',
  'Wellington',
  'West Coast',
];

// 50 states of the United States
export const statesOfTheUnitedStates = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
]; // to be tested

export const getStateOrProvinceListByCountry = (country: string) => {
  switch (country) {
    case countryList.Australia:
      return statesAndTerritoriesOfAustralia;
    case countryList.Canada:
      return provincesAndTerritoriesOfCanada;
    case countryList.New_Zealand:
      return regionsAndTerritoriesOfNewZealand;
    case countryList.United_States:
      return statesOfTheUnitedStates;
    default:
      return [];
  }
};

export const getStateOrProvinceOrRegionLabelByCountry = (country: string) => {
  switch (country) {
    case countryList.Australia:
      return 'State or Territory';
    case countryList.Canada:
      return 'Province';
    case countryList.New_Zealand:
      return 'Region';
    case countryList.United_States:
      return 'State';
    default:
      return '';
  }
};

export const getCountryShortName = (country: string) => {
  switch (country) {
    case countryList.Australia:
      return 'AU';
    case countryList.Canada:
      return 'CA';
    case countryList.New_Zealand:
      return 'NZ';
    case countryList.United_States:
      return 'US';
    default:
      return '';
  }
};
